import type { FaireProductEntity } from "../../entity_types/product";

export const p_3undzt9r8p: FaireProductEntity = {
  token: "p_3undzt9r8p",
  type: "product",
  name: "Winslow Non-Tarnish Green Stone Pendant Chain Necklace",
  brandToken: "b_3tzh9mjdm6",
  brandName: "Flânerie by MAIQ",
  imageUrl:
    "https://cdn.faire.com/fastly/184af9295caf67e7871cef475d47291e617b4cf56018a45735894158dbfeb4e0.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0de1fc404faea6826dc7e0012e02899594fdbf974b60215f0579f371feaa4cf5.jpeg",
    "https://cdn.faire.com/fastly/c802d3be3fd4d8973540334e91651f45dedb3a1335f0dd36d70abf6b2f916923.jpeg",
    "https://cdn.faire.com/fastly/8e34aa0f0e4df7ba4242a200b10c83073af5c67149c27ccc86b2723700daf126.jpeg",
    "https://cdn.faire.com/fastly/1c7ed31b82129fe235280b4c36989e2f8489da8614b358464ff045d42e0c8936.jpeg",
    "https://cdn.faire.com/fastly/db07037eccc71df1b878ee910d369540dd4dac40becc0544c859c62c917b24fc.jpeg",
  ],
  priceDollars: 7.64,
  description:
    'Non-Tarnish Green Stone Pendant Chain Necklace\n\n• Stainless Steel\n• Green Gemstone\n• 18k Gold Chain\n• Pendant Size (inch): 0.5 x 0.4\n• Chain Length (inch): 15\n• Extension Length (inch): 2"\n\n• Lead-free, Nickel-safe\n• Hypoallergenic\n• Water Resistant',
  tags: [],
  msrpDollars: 24,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:21.328Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
